<!--  -->
<template>
  <div>
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input v-model="query.user_id" clearable style="width:200px;" placeholder="请输入员工id" /> -->
        <!-- <el-input v-model="query.corp_id" clearable style="width:200px;margin:0px 10px" placeholder="请输入公众号appid" /> -->
        <!-- <el-input v-model="query.suite_id" clearable style="width:200px;" placeholder="请输入应用id" /> -->
        <el-input
          v-model="query.corp_keywords"
          clearable
          style="width:400px;"
          placeholder="请输入企业id/名称"
        />
        <el-input
          v-model="query.keywords"
          clearable
          style="width:400px;"
          placeholder="请输入员工id/员工编号"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
      </div>
      <div>
        <!-- <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button> -->
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      max-height="550"
    >
      <el-table-column
        prop="name"
        label="企业名称/id"
        align="center"
        min-width="300"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.corp_name }}({{ scope.row.corp_id }})</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名字"
        align="center"
        min-width="150px"
      />
      <el-table-column
        prop="user_id"
        label="员工id"
        align="center"
        min-width="300px"
      />
      <el-table-column
        prop="employee_no"
        label="员工编号"
        align="center"
        min-width="250px"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="choose(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>

    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spCorpcorpUsersList } from '@/api/officialaccount.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null,
        onlyMe: null,
        corp_keywords: null
        // user_id: null,
        // corp_id: null
      }
    }
  },
  created() {
    // this.list()
  },
  mounted() {},
  methods: {
    async list() {
      this.loading = true
      const data = await spCorpcorpUsersList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      // console.log('data', data)
    },
    open() {
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.corp_keywords = null
      // this.query.user_id = null
      this.list()
    },
    choose(item) {
      this.$emit('callspWork', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box {
  text-align: center;
}
</style>
